import { Component, OnInit, OnDestroy, HostListener, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'wassceeligibilitypopup',
  templateUrl: './wassceeligibilitypopup.component.html',
  styleUrls: ['./wassceeligibilitypopup.component.scss']
})
export class WassceeligibilitypopupComponent implements OnInit, OnDestroy {

  /** Delay (ms) before popup appears on page load. Default: 3000ms */
  @Input() delayMs: number = 3000;

  /** Scroll percentage (0–100) at which popup triggers. Default: 30% */
  @Input() scrollTriggerPercent: number = 30;

  /** URL to open when user clicks "Check My Eligibility" */
  @Input() eligibilityUrl: string = 'https://techbridge.edu.gh/eligibility/';

  isVisible: boolean = false;
  isDismissed: boolean = false;
  isAnimatingOut: boolean = false;

  private timer: ReturnType<typeof setTimeout> | null = null;
  private hasTriggered: boolean = false;

  ngOnInit(): void {
    this.timer = setTimeout(() => {
      if (!this.hasTriggered && !this.isDismissed) {
        this.showPopup();
      }
    }, this.delayMs);
  }

  ngOnDestroy(): void {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    if (this.hasTriggered || this.isDismissed) return;

    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const docHeight =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;
    const scrollPercent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;

    if (scrollPercent >= this.scrollTriggerPercent) {
      this.showPopup();
    }
  }

  showPopup(): void {
    if (this.isDismissed) return;
    this.hasTriggered = true;
    this.isVisible = true;
    this.isAnimatingOut = false;
  }

  dismissPopup(): void {
    this.isAnimatingOut = true;
    setTimeout(() => {
      this.isVisible = false;
      this.isDismissed = true;
      this.isAnimatingOut = false;
    }, 400);
  }

  reopenPopup(): void {
    this.isDismissed = false;
    this.showPopup();
  }

  openEligibility(): void {
    window.open(this.eligibilityUrl, '_blank', 'noopener,noreferrer');
  }
}